import { alpha, styled } from "@mui/material";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";

export const StyledTreeView = styled(SimpleTreeView)(({ theme }) => ({
	height: "100%",
	width: "100%",
	padding: theme.spacing(0.5),

	"& .MuiTreeItem-content": {
		minHeight: 40,
		padding: theme.spacing(0.125, 1),
		borderRadius: 2,
		border: `1px solid transparent`,
		transition: "background-color .15s ease, border-color .15s ease",

		"&:hover": {
			backgroundColor:
				theme.palette.mode === "light"
					? alpha(theme.palette.text.primary, 0.025)
					: alpha(theme.palette.text.primary, 0.06),
		},

		"&.Mui-focused": {
			borderColor: alpha(theme.palette.primary.main, 0.35),
			backgroundColor:
				theme.palette.mode === "light"
					? alpha(theme.palette.primary.main, 0.04)
					: alpha(theme.palette.primary.main, 0.08),
		},

		"&.Mui-selected": {
			backgroundColor:
				theme.palette.mode === "light"
					? alpha(theme.palette.primary.main, 0.06)
					: alpha(theme.palette.primary.main, 0.12),
			borderColor: alpha(theme.palette.primary.main, 0.35),
			"&:hover": {
				backgroundColor:
					theme.palette.mode === "light"
						? alpha(theme.palette.primary.main, 0.08)
						: alpha(theme.palette.primary.main, 0.16),
			},
		},

		"& .MuiTreeItem-label": {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			width: "100%",
			fontSize: theme.typography.body2.fontSize,
		},
	},

	"& .MuiTreeItem-groupTransition": {
		marginLeft: theme.spacing(0.75),
		paddingLeft: theme.spacing(0.875),
		borderLeft: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
	},
}));
